import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { CPQComponent } from '../../Pricing/cpq/cpq.component';
import { PriceBreakComponent } from '../../Pricing/price-break/price-break.component';
import { ItemSearchComponent } from '../../shared/components/popups/item-search/item-search.component';
import { CPQSelectionSummary, CPQUI } from '../../shared/models/CPQUI';
import { Distributor } from '../../shared/models/Distributor';
import { ItemPricing } from '../../shared/models/ItemPricing';
import { User } from '../../shared/models/User';
import { GlobalService } from '../../shared/services/global';
import { HttpService } from '../../shared/services/HttpService';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { Item } from '../../shared/models/Item';
import { Subscription } from 'rxjs';
import { FilterObject } from '../../shared/models/FilterObject';
import { PagingResults } from '../../shared/models/PagingResult';
import { ModalComponent } from '../../shared/components/modal/modal.component';

@Component({
  selector: 'app-dashboard-quickprice',
  templateUrl: './quickprice.component.html',
  styleUrls: ['./quickprice.component.css']
})
export class QuickpriceComponent implements OnInit, OnDestroy {
  readonly Page: string = "Pricing";
  ConfigString: string;
  Quantity: number;
  ConfiguredPrice: number;
  CurrentCPQSessionID: string;
  CurrentCPQUI: CPQUI;
  CurrentDist: Distributor;
  HideDist: boolean;
  DistList: Distributor[];
  DistSubscription: Subscription;
  CurrentUser: User
  HideSearch: boolean;
  HideComponent: boolean;
  //PriceBreaks: ItemPricing[];
  ItemList: Item[];
  ShowBreakPrice: boolean;
  faSearch = faSearch;
  CurrentOpenDialog: MatDialogRef<ModalComponent, any>;
  InvalidItem: boolean;
  OverrideBreakPricingRule: boolean;
  hideLoadingModal: boolean;
  MessagesForSummary: string[];
  //@ViewChild(PriceBreakComponent) PriceBreakComp: PriceBreakComponent;

  constructor(private http: HttpService, private global: GlobalService, public matDialog: MatDialog) { }


  ngOnInit(): void {
    this.hideLoadingModal = true;
    this.CurrentDist = new Distributor();
    this.CurrentUser = new User();
    this.InvalidItem = false;
    this.OverrideBreakPricingRule = false;
    this.ConfigString = "";
    this.HideSearch = false;
    this.HideComponent = false;
    this.MessagesForSummary = [];
    this.global.getCurrentUser().then(x => {
      this.CurrentUser = x;
      if (this.CurrentUser != null) {
        if (!this.CurrentUser.HasPagePermission("pricing")) {
          this.HideComponent = true;
        }
        this.HideSearch = false;
        this.ItemList = [];
        this.ShowBreakPrice = true;
        
        this.DistSubscription = this.global.CurrentDist.subscribe(dist => {
          if (dist) {
            this.CurrentDist = dist;
          }
        });
        if (this.CurrentUser.IsTolomaticUser) {
          this.HideDist = false;
        }
        else {
          this.HideDist = true;
        }
        this.global.GetDistList().then(x => {
          this.DistList = x;
          //this.DistList = this.DistList.filter(x => x.CstaccountNumber != null && x.CstaccountNumber.length > 0);
          this.global.getCurrentDist().then(dist => {
            if (dist) {
              if (!this.CurrentUser.IsTolomaticUser && this.CurrentUser.DistributorId == dist.CompanyId) {
                this.CurrentDist = dist;
              }
              else if (this.CurrentUser.IsTolomaticUser) {
                this.CurrentDist = dist;
              }
              else {
                this.CurrentDist = this.CurrentUser.Distributor;
              }
            }
            else {
              if (!this.CurrentUser.IsTolomaticUser && this.CurrentUser.DistributorId != "") {
                this.CurrentDist = this.CurrentUser.Distributor;
              } else {
                this.CurrentDist = this.DistList[0];
              }
            }
          });
        });
        
      }
      else {
        this.HideComponent = true;
      }
    });
  }

  ngOnDestroy() {
    if (this.DistSubscription) {
      this.DistSubscription.unsubscribe();
    }

  }

  PriceItem(itemNumber: string,trimEightDigit:boolean = true) {
    this.InvalidItem = false;
    this.OverrideBreakPricingRule = false;
    if (this.ConfigString.length > 0) {
      this.hideLoadingModal = false;
      if (/^[\d]{1}/.test(this.ConfigString)) {//Eight digit part
        debugger;
        this.ConfigString = this.ConfigString.replace("-", "");
        //Have to get rid of everything after the 8 digits because CPQ isn't set up to decode all 8 digit configurables -- JWelter 12/03/2025
        if (trimEightDigit) {
          this.ConfigString = this.ConfigString.replace(" ", "").trim();
        }
        else {
          this.ConfigString = this.ConfigString.replace(" ", "");
        }
        
        this.http.PostUserActivity(this.CurrentUser.UserId.toString(), "Quick Price", "Price 8-Digit Item", this.ConfigString, this.CurrentUser.IsTolomaticUser ? this.CurrentDist.CompanyId : this.CurrentUser.DistributorId);
        var FilterList = [];
        var ItemNumberSearch = new FilterObject();
        if (trimEightDigit) {
          itemNumber = itemNumber.replace("-", "").trim();
          ItemNumberSearch.Value = this.ConfigString.trim();
        }
        else {
          itemNumber = itemNumber.replace("-", "");
          ItemNumberSearch.Value = this.ConfigString;
        }
        
        
        ItemNumberSearch.Key = "item";
        
        FilterList.push(ItemNumberSearch);
        var CustomerSearch = new FilterObject();
        CustomerSearch.Key = "customer";
        CustomerSearch.Value = "";
        if (this.CurrentDist && this.CurrentDist.Permissions && this.CurrentDist.Permissions.length > 0 && this.CurrentDist.Permissions.some(x => x.Page.toLowerCase() == "pricing" && x.Action.toLowerCase() == "contract")) {
          CustomerSearch.Value = this.CurrentDist.CstaccountNumber;
          this.OverrideBreakPricingRule = true;
          FilterList.push(CustomerSearch);
          this.http.AdvancedItemSearch(FilterList, 0, 10).then(x => {
            var results = <PagingResults>x;
            var foundItem;
            for (var i = 0; i < results.Items.length; i++) {
              foundItem = <Item>results.Items[i];
              break;
            }

            if (results.Items.length > 0 && foundItem != undefined && foundItem && foundItem.OrderConfigurable) {//Means it's a 8 digit configured
              this.StartCPQProcess(true);
            }
            else {
              this.http.GetBreakPricing(this.CurrentDist.CompanyId, itemNumber,itemNumber).then(wrap => {
                if (wrap.StatusCode == "200") {
                  this.HideSearch = true;
                  this.ShowBreakPrice = true;
                  var newItem = new Item();
                  newItem.Item = itemNumber;
                  newItem.Pricing = wrap.Content;
                  newItem.BuildPricing();
                  if (!newItem.Pricing || (newItem.Pricing.length > 0 && newItem.Pricing[0].ItemStatus == 'O')) {
                    this.OverrideBreakPricingRule = true;
                  }
                  this.ItemList.push(newItem);
                  this.hideLoadingModal = true;
                  //this.PriceBreakComp.ItemPriceList.push(newItem);
                  //this.PriceBreakComp.BuildPricing();
                }
                else if (wrap.StatusCode == "300" && wrap.Content == true) {
                  this.HideSearch = true;
                  this.ShowBreakPrice = true;
                  this.OverrideBreakPricingRule = true;
                  var newItem = new Item();
                  newItem.Item = itemNumber;
                  newItem.Description = "Please contact Tolomatic to see pricing on this item."
                  newItem.Pricing = [];
                  var newPricing = new ItemPricing();
                  newPricing.ItemStatus = 'I';
                  newItem.Pricing.push(newPricing);

                  newItem.BuildPricing();
                  this.ItemList.push(newItem);
                  this.hideLoadingModal = true;
                } else if (wrap.StatusCode == "400") {
                  this.OverrideBreakPricingRule = true;
                  this.HideSearch = true;
                  var newItem = new Item();
                  newItem.Item = itemNumber;
                  this.ItemList.push(newItem);
                  this.hideLoadingModal = true;
                } else {
                  //Didn't find an item
                  this.InvalidItem = true;
                  this.hideLoadingModal = true;
                }
              });
            }
          });
        } else {
          this.OverrideBreakPricingRule = false;
          this.http.ItemSearch(FilterList, 0, 10).then(x => {
            var results = <PagingResults>x;
            var foundItem;
            for (var i = 0; i < results.Items.length; i++) {
              foundItem = <Item>results.Items[i];
              break;
            }

            if (results.Items.length > 0 && foundItem && foundItem.OrderConfigurable) {//Means it's a 8 digit configured
              this.StartCPQProcess(true);
            }
            else {
              this.http.GetBreakPricing(this.CurrentDist.CompanyId, itemNumber,itemNumber).then(wrap => {
                if (wrap.StatusCode == "200") {
                  this.HideSearch = true;
                  this.ShowBreakPrice = true;
                  var newItem = new Item();
                  newItem.Item = itemNumber;
                  newItem.Pricing = wrap.Content;
                  newItem.BuildPricing();
                  if (newItem.Pricing.length > 0 && newItem.Pricing[0].ItemStatus == 'O') {
                    this.OverrideBreakPricingRule = true;
                  }
                  this.ItemList.push(newItem);
                  this.hideLoadingModal = true;
                  //this.PriceBreakComp.ItemPriceList.push(newItem);
                  //this.PriceBreakComp.BuildPricing();
                } else if (wrap.StatusCode == "300") {
                  //Didn't find an item
                  this.InvalidItem = true;
                  this.hideLoadingModal = true;
                } else if (wrap.StatusCode == "400") {
                  this.InvalidItem = true;
                  this.hideLoadingModal = true;
                }
              });
            }
            //else {
            //  this.InvalidItem = true;
            //}
          });

        }



      }
      else {//config string

        //this.http.PostUserActivity(this.CurrentUser.UserId.toString(), "Quick Price", "Price Configured Item", this.ConfigString);
        this.StartCPQProcess(false);

      }
    }
  }

  StartCPQProcess(openUI: boolean) {
    if (openUI) {
      this.CreateNewConfig(null);
    }
    else {
      this.http.CPQConfigureStart(this.ConfigString, true).then(wrap => {
        //this.hideLoadingModal = false;
        this.CurrentCPQSessionID = wrap.Content;
        this.http.CPQInitialize(this.CurrentCPQSessionID).then(wrap2 => {
          this.CurrentCPQSessionID = wrap2.Content;

          this.http.CPQConfigureUpdate(this.CurrentCPQSessionID, "", "").then(wrap3 => {
            var cpqUI = <CPQUI>wrap3.Content;
            if (this.CheckForRequired(cpqUI)) {
              var temp = this.PullPriceFromCPQUI(cpqUI);
              this.MessagesForSummary = [];
              var cpqConfigString = this.getConfigStringFromCPQUI(cpqUI);

              this.http.PostUserActivity(this.CurrentUser.UserId.toString(), "Quick Price", "Price Configured Item", cpqConfigString, this.CurrentUser.IsTolomaticUser ? this.CurrentDist.CompanyId : this.CurrentUser.DistributorId);

              var messages = this.PullMessagesFromCPQUI(cpqUI);


              var selSummary = this.getSelectionSummaryFromCPQUI(cpqUI);
              this.PriceConfigured(cpqConfigString, temp, selSummary);
              
              this.hideLoadingModal = true;
              if (messages.length > 0) {
                this.ShowCPQMessages(messages);
              }
            }
            else {
              this.CreateNewConfig(cpqUI);
              this.hideLoadingModal = true;
            }
          });
        });
      });
    }
  }


  CheckForRequired(cpq: CPQUI): boolean {
    var isValid = true;
    cpq.Pages.forEach(page => {
      page.Screens.forEach(screen => {
        screen.ScreenOptions.forEach(opt => {
          if (opt.IsRequired && (opt.Value == "")) {
            isValid = false;
          }
          else if (opt.IsValid == false) {
            isValid = false;
          }
        });
      });
    });
    return isValid;
  }

  getSelectionSummaryFromCPQUI(cpq: CPQUI): string {
    debugger;
    var summary = "";
    var selectionArray = [];
    cpq.SelectionSummary.forEach(ss => {
      if ((ss.Caption && ss.Value) && ss.Caption.length > 0 && ss.Value.length > 0 && (ss.Value != "No" && ss.Value != "None" && ss.Value != "False")) {
        var newSum = new CPQSelectionSummary();
        newSum.Caption = this.stripTags(ss.Caption);
        newSum.Value = ss.Value;
        selectionArray.push(newSum);
      }
    });

    cpq.Details.forEach(detail => {

      if (detail.Caption.toLowerCase().indexOf("selection summary") < 0 && detail.Caption.toLowerCase().indexOf("price") < 0 && detail.Value == "" && detail.Caption.length > 0) {
        summary += "<span>" + this.stripTags(detail.Caption) + "</span><br />";
      }
    });
    if (this.MessagesForSummary.length > 0) {
      for (var i = 0; i < this.MessagesForSummary.length; i++) {
        summary += "<span>" + this.MessagesForSummary[i] + "</span><br />";
      }
    }

    return summary;
  }

  getConfigStringFromCPQUI(cpq: CPQUI): string {
    var config = "";

    if (cpq && cpq.Details && cpq.Details.length > 0) {
      var filtered = cpq.Details.filter(x => x.Caption.toLowerCase() == "config string")[0];
      if (filtered) {
        config = filtered.Value;
      }
    }

    //if (config == "") {
    //  config = this.ConfigString;
    //}

    return config;
  }

  stripTags(input: string): string {
    return input.replace(/(<([^>]+)>)/gi, "");
  }

  PullPriceFromCPQUI(cpq: CPQUI): number {
    debugger;
    var priceDetails = cpq.Details.filter(x => x.Caption.toLowerCase().indexOf('price') >= 0);
    var totalPrice = 0.0;
    //priceDetails.forEach(price => {
    //  totalPrice += this.ParseCurrency(price.Value, 2);
    //});

    //this.CurrentPrice = totalPrice;
    var lastPrice = priceDetails[priceDetails.length - 1];
    if (lastPrice && lastPrice.Value) {
      return this.ParseCurrency(lastPrice.Value, 2);
      //this.ActionButtonDisabled = false;
    }
    else {
      return 0;
    }
  }

  PullMessagesFromCPQUI(cpq: CPQUI): string {
    debugger;
    var messages = "";
    var dupeCheck = [];
    for (var i = 0; i < cpq.Messages.length; i++) {
      if (cpq.Messages[i].Value.indexOf("Note:") >= 0) {
        if (dupeCheck.filter(x => x == cpq.Messages[i].Value).length == 0) {
          if (cpq.Messages[i].Value.toLowerCase().indexOf('config string') < 0) {
            messages += cpq.Messages[i].Value + "\r\n";
            dupeCheck.push(cpq.Messages[i].Value);
          }
        }
      }
    }
    for (var i = 0; i < dupeCheck.length; i++) {
      if (this.MessagesForSummary.filter(x => x == dupeCheck[i]).length == 0) {
        this.MessagesForSummary.push(dupeCheck[i]);
      }
    }
    var htmlRegex = /[<].*?[>]/g;//new RegExp('[<].*[>]');

    messages = messages.replace(htmlRegex, '');

    messages = messages.trimLeft();
    return messages;
  }

  ShowCPQMessages(messages: string) {
    var dialogConfig = this.GetDialogConfig("CPQMessages");

    var rmaObject = { type: "Messages", object: [messages] };
    dialogConfig.data = rmaObject;

    this.CurrentOpenDialog = this.matDialog.open<ModalComponent>(ModalComponent, dialogConfig);

    this.CurrentOpenDialog.componentInstance.ActionEventEmitter.addListener("actionEvent", (event) => {
      this.CurrentOpenDialog.close();
    });

    this.CurrentOpenDialog.componentInstance.CloseEventEmitter.addListener("closeEvent", (event) => {
      this.CurrentOpenDialog.close();
    });
  }


  GetDialogConfig(name: string): MatDialogConfig {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = name;
    dialogConfig.height = "50%";
    dialogConfig.width = "50%";

    return dialogConfig;
  }

  PriceConfigured(configuredString: string, configuredPrice: number, selectionSummary: string) {
    if (configuredString.length <= 5) {
      this.InvalidItem = true;
      return;
    }

    var productRegex = /^([0-9]{8}|CC|PB|MG|LS|IMA[S]?|BC[2-4]|[A-Z]{2,3}|[A-Z][\d][A-Z])/i;
    var configReg = productRegex.exec(configuredString);
    var item = configReg[0];
    debugger;
    this.http.GetBreakPricing(this.CurrentDist.CompanyId, item,configuredString).then(wrap => {
      if (wrap.StatusCode == "200") {
        if (wrap.Content) {
          this.HideSearch = true;
          //this.ShowBreakPrice = true;
          var newItem = new Item();
          newItem.Item = configuredString;
          newItem.ConfigHasChanged = configuredString != this.ConfigString && this.ConfigString != "";
          newItem.SelectionSummary = selectionSummary;
          newItem.Pricing = wrap.Content;
          newItem.Pricing.forEach(x => {
            x.UnitPrice = configuredPrice;
          });
          newItem.BuildPricing();
          this.ItemList.push(newItem);
          this.ConfigString = "";
          this.hideLoadingModal = true;
        } else {
          this.hideLoadingModal = true;
        }
      }
      else if (wrap.StatusCode == "300" && wrap.Content == true) {

        this.HideSearch = true;
        this.OverrideBreakPricingRule = true;
        var newItem = new Item();
        newItem.Item = configuredString;
        newItem.SelectionSummary = selectionSummary;
        newItem.ConfigHasChanged = configuredString != this.ConfigString && this.ConfigString != "";
        newItem.Description = "Please contact Tolomatic to see pricing on this item."
        this.OverrideBreakPricingRule = true;
        newItem.Pricing = [];
        //var newPricing = new ItemPricing();        
        //newItem.Pricing.push(newPricing);

        //newItem.BuildPricing();
        this.ItemList.push(newItem);
        //this.BuildItemListIndexes();
        this.hideLoadingModal = true;
      }
      //return new ItemPricing();
    });
  }

  SearchForItem() {
    var dialogConfig = {
      width: '60%',
      height: '80%'
    };
    var currentDialog = this.matDialog.open(ItemSearchComponent, dialogConfig);
    currentDialog.componentInstance.EnteredItemNumber = this.ConfigString;

    currentDialog.componentInstance.ActionEventEmitter.subscribe(item => {
      if (item) {
        this.ConfigString = item.Item;
        this.http.PostUserActivity(this.CurrentUser.UserId.toString(), "Quick Price", "Item Search", item.Item, this.CurrentUser.IsTolomaticUser ? this.CurrentDist.CompanyId : this.CurrentUser.DistributorId);
        this.PriceItem(item.Item,false);
        currentDialog.close();
      }
    });

    currentDialog.componentInstance.CloseEventEmitter.subscribe((event) => {
      currentDialog.close();
    });
  }


  CreateNewConfig(cpqUI: CPQUI) {
    var dialogConfig = {
      width: '80%',
      height: '80%'
    };
    this.hideLoadingModal = true;
    var currentDialog = this.matDialog.open(CPQComponent, dialogConfig);

    currentDialog.componentInstance.EnteredCFGString = this.ConfigString;
    if (cpqUI) {
      currentDialog.componentInstance.CurrentCPQUI = cpqUI;
      currentDialog.componentInstance.CurrentCPQSessionID = this.CurrentCPQSessionID;
    }
    currentDialog.componentInstance.ActionEventEmitter.subscribe((event) => {
      this.ShowBreakPrice = true;
      this.HideSearch = true;

      var args = event;
      var newItem = new Item();
      newItem.Item = args.configString;

      this.PriceConfigured(newItem.Item, args.CurrentPrice, args.selectionSummary);
      this.http.PostUserActivity(this.CurrentUser.UserId.toString(), "Quick Price", "Price Configured Item", newItem.Item, this.CurrentUser.IsTolomaticUser ? this.CurrentDist.CompanyId : this.CurrentUser.DistributorId);
      //var args = event;
      //var newItem = new Item();
      //newItem.Item = args.configString;
      //var pricing = new ItemPricing();
      //pricing.UnitPrice = args.CurrentPrice;
      //newItem.Pricing.push(pricing);
      //newItem.BuildPricing();
      //this.ItemList.push(newItem);

      currentDialog.close();

    });

    currentDialog.componentInstance.CloseEventEmitter.subscribe((event) => {
      this.ConfigString = "";
      currentDialog.close();
    });
  }

  ParseCurrency(str: string, precision: number) {
    return Number(str.slice(0, (str.indexOf('.')) + precision + 1));
  }

  BackToSearch() {
    //this.PriceBreaks = [];
    this.ItemList = [];
    this.HideSearch = false;
    this.ConfigString = "";
    this.ConfiguredPrice = 0.0;
    //this.PriceBreakComp.ClearPricing();
  }

  Dist_Change(event: any) {
    var newDist = this.DistList.filter(x => x.CompanyId == event.value)[0];
    this.CurrentDist = newDist;

    this.global.setCurrentDist(newDist);
  }
}
